module.exports = __webpack_public_path__ + "img/icon11.0ba6377f.png";